<template>
  <ControlCenterLayout type="api">
    <BaseLayout>
      <div class="tw-flex tw-gap-5 tw-w-full lg:tw-mt-8 tw-mt-5 tw-mb-20">
        <div
          v-if="$route.path !== '/controlCenter/shopping-cart'"
          class="user-menu tw-hidden md:tw-block lg:tw-w-44 tw-w-26 tw-flex-none tw-rounded-lg tw-bg-white tw-py-5"
          style="height: 786px"
        >
          <div v-for="item in filteredMenuGroups" :key="item.title" class="tw-mb-4">
            <!-- 一级菜单标题（不可点击） -->
            <div
              class="tw-text-xs tw-text-textLight lg:tw-pl-7 tw-px-2 tw-pb-4"
            >
              {{ $t(item.title) }}
            </div>

            <!-- 二级菜单列表 -->
            <ul class="tw-list-none tw-flex tw-flex-col tw-gap-2">
              <li
                v-for="im in item.items"
                :key="im.path"
                class="tw-rounded-lg tw-font-medium tw-text-sm lg:tw-pl-7 tw-py-2 tw-mx-2.5 tw-cursor-pointer tw-text-textMain menu-hover"
                :class="{ 'menu-active': isMenuActive(im.path) }"
                @click="handleMenuClick(im.path)"
              >
                <span class="tw-font-semibold menu-item-active">
                  {{ $t(im.label) }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="tw-flex-1 app-center"
          :class="{ 'app-main': !paths.includes(path) }"
        >
          <router-view></router-view>
        </div>
      </div>
    </BaseLayout>
  </ControlCenterLayout>
</template>

<script>
import BaseLayout from "@/layout/BaseLayout.vue";
import ControlCenterLayout from "@/layout/ControlCenterLayout.vue";
export default {
  name: "UserCenter",
  components: { BaseLayout, ControlCenterLayout },
  data() {
    return {
      paths: [
        "/controlCenter/personal-setting",
        "/controlCenter/account-authentication",
        "/controlCenter/shopping-cart",
      ],
      menuGroups: [
        {
          title: "账户与个人信息",
          items: [
            { label: "个人中心", path: "/controlCenter/personal-setting" },
            {
              label: "账号认证",
              path: "/controlCenter/account-authentication",
            },
            { label: "我的反馈", path: "/controlCenter/my-feedback" },
          ],
        },
        {
          title: "订单与消费",
          items: [
            { label: "我的订单", path: "/controlCenter/my-order" },
            { label: "合同订单", path: "/controlCenter/contract-orders" },
            { label: "续订管理", path: "/controlCenter/renewal-management" },
            { label: "流量费", path: "/controlCenter/postpaid-list" },
          ],
        },
        {
          title: "财务与资产",
          items: [
            { label: "我的账单", path: "/controlCenter/bill-management" },
            { label: "我的优惠券", path: "/controlCenter/coupon-management" },
            { label: "解除限制", path: "/controlCenter/unfreeze-astrict" },
          ],
        },
      ],
    };
  },
  computed: {
    isPostpaidPayRoute() {
      return this.$route.path.startsWith("/controlCenter/postpaid-pay/");
    },
    // 路径
    path() {
      return this.$route.path;
    },
    filteredMenuGroups() {
      const userInfo = localStorage.getItem("userInfo");
      if (!userInfo) return this.menuGroups;
      
      try {
        const user = JSON.parse(userInfo);
        if (user.userType === 2) {
          const groups = JSON.parse(JSON.stringify(this.menuGroups));
          const partnerItem = { 
            label: "合作伙伴中心", 
            path: "/controlCenter/partner-center" 
          };
          groups[0].items.splice(3, 0, partnerItem);
          return groups;
        }
      } catch (error) {
        console.error('解析用户信息失败', error);
      }
      
      return this.menuGroups;
    },
  },
  created() {},
  methods: {
    isMenuActive(path) {
      if (path === "/controlCenter/contract-orders") {
        return (
          this.$route.path.startsWith(path) ||
          this.$route.path.startsWith("/controlCenter/contract-collection-bill")
        );
      }
      return this.$route.path.startsWith(path);
    },
    handleMenuClick(path) {
      // TODO 账号认证
      // if (path == "/controlCenter/account-authentication") {
      //   this.$toast(this.$t("暂未开放"), {
      //     type: "center",
      //     timeout: 1000,
      //   });
      //   return;
      // }
      this.$router.push(path);
      this.$store.commit("SET_CURRENTSTEP", null);
      this.$store.commit("SET_ORDERTYPE", null);
    },
  },
};
</script>

<style scoped lang="scss">
.menu-active {
  @apply tw-text-primary;
  background: rgba(64, 119, 248, 0.1);
  color: #4077f8;
}
.user-menu {
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.02);
}
.menu-hover:hover {
  background: rgba(64, 119, 248, 0.1);
}

.app-main {
  overflow-x: auto;
  // margin-left: 20px !important;

  & > div:first-of-type {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.02);
  }
}

@media (max-width: 768px) {
  .app-main {
    overflow-x: auto;
    padding: 0 16px;
    & > div:first-of-type {
      width: 100%;
      height: 100%;
      // background-color: transparent;
      border-radius: 10px;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.02);
    }
  }
}
</style>
